module.exports = __webpack_public_path__ + "img/差评.41872722.png";